import React from 'react';
export function HeroSection() {
  return <section id="home" className="relative w-full bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-124">
      <div className="container mx-auto px-4 flex flex-col items-center" data-id="element-125">
        <div className="w-full max-w-4xl text-center" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-127">
            专业量化交易解决方案
          </h2>
          <p className="text-lg md:text-xl text-blue-100 mb-8" data-id="element-128">
            利用先进的算法和技术，为您的投资策略提供稳定可靠的量化交易服务
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-129">
            <button className="bg-white text-blue-800 hover:bg-blue-50 font-medium py-3 px-6 rounded-lg shadow-md transition-all" data-id="element-130">
              了解更多
            </button>
            <button className="bg-transparent text-white hover:bg-blue-800 border border-white font-medium py-3 px-6 rounded-lg shadow-md transition-all" data-id="element-131">
              联系我们
            </button>
          </div>
        </div>
        <div className="w-full mt-16 flex justify-center" data-id="element-132">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-4xl" data-id="element-133">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-lg text-center" data-id="element-134">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-135">数据驱动</h3>
              <p className="text-blue-100" data-id="element-136">
                基于大数据分析和机器学习的精准交易策略
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-lg text-center" data-id="element-137">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-138">技术领先</h3>
              <p className="text-blue-100" data-id="element-139">
                采用行业领先的高频交易技术和基础设施
              </p>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-lg text-center" data-id="element-140">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-141">风险可控</h3>
              <p className="text-blue-100" data-id="element-142">
                完善的风控体系，确保投资安全和收益稳定
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}